import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchExams,
  getExams,
  getExamsStatus,
  getExamsError,
} from "../../../redux/slice/examsSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import UpperSection from "../common/UpperSection";
import ExamList from "./ExamList";

const AdminExam = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const exams = useSelector(getExams);
  const status = useSelector(getExamsStatus);
  const error = useSelector(getExamsError);

  useEffect(() => {
    if (exams.length === 0) {
      dispatch(fetchExams());
    }
  }, [dispatch, exams]);

  const filteredExams = exams?.filter((exam) => {
    return exam?.topicName?.toLowerCase().includes(searchQuery);
  });

  const handleCreateExam = () => {
    navigate("/admin/create-exam");
  };

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type={status} message={error} /> : null}
      {/* Upper Section */}
      <UpperSection
        title="Exams"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      {/* Lower section */}
      <section className="bg-primary flex flex-col gap-4 w-full sm:p-7 p-2 rounded-[4px] border border-adminMainBorder">
        {/* Upper Section */}
        <div className="flex flex-row w-full justify-between items-center">
          <span className="text-textPrimary text-[18px] font-semibold">
            Exam List
          </span>
          <div className="flex flex-row gap-6 text-adminRightTextPrimary">
            <button
              type="button"
              onClick={handleCreateExam}
              className="border-adminRightTextPrimary border sm:w-[180px] w-[50px] sm:h-[32px] h-[28px] rounded-[4px] text-adminRightTextPrimary flex gap-3 justify-center items-center"
            >
              <FaPlus />
              <span className="sm:block hidden">Create Exam</span>
            </button>
          </div>
        </div>
        {status === "success" ? <ExamList exams={filteredExams} /> : null}
      </section>
    </section>
  );
};

export default AdminExam;
